import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';

import React, { useState, useEffect, useRef } from 'react';

const SCPConfigDropdown = ({ options, value, onChange, name, idKey, displayKey, disabled = false, enableScrollEffect=false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const dropdownRef = useRef(null);
  const optionsRef = useRef(null);

  useEffect(() => {
    const mainContainer = document.querySelector('.main_container');
    if (!mainContainer) return;
  
    if (isOpen) {
      // console.log("enableScrollEffect", enableScrollEffect);
      if(!enableScrollEffect) return;
      setTimeout(() => {
        const dropdownHeight = optionsRef.current?.offsetHeight || 100;
        const gap = 2;
  
        mainContainer.style.paddingBottom = `${dropdownHeight + gap}px`;
        mainContainer.scrollTo({
          top: mainContainer.scrollHeight,
          behavior: 'smooth',
        });
      }, 100);
    } else {
      if(!enableScrollEffect) return;
      mainContainer.style.paddingBottom = '';
    }
  }, [isOpen]);  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  useEffect(() => {
    if (disabled) setIsOpen(false);
  }, [disabled]);
  

  const handleToggleDropdown = () => {
    if (disabled) return;
    setIsOpen(!isOpen);
  };

  const handleSelectOption = (option) => {
    if (disabled) return;
    setSelectedValue(option[idKey]);
    setIsOpen(false);
    onChange({ target: { name, value: option[idKey] } });
  };

  const selectedOption = options.find(option => option[idKey] === selectedValue);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>

      <div className="custom-dropdown__selected" onClick={handleToggleDropdown} style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto'
      }}>
        {selectedOption ? selectedOption[displayKey] : 'No'}
        <span className="custom-dropdown__caret">
          {isOpen ? <IoCaretUpOutline /> : <IoCaretDownOutline />}

        </span>
      </div>
      {isOpen && (
        <div className="custom-dropdown__options">
          {options.map((option) => (
            <div
              key={option[idKey]}
              className="routing_select-box"
              style={{display: 'flex', alignItems: 'center', justifyContent:'center'}}
              onClick={() => handleSelectOption(option)}
            >
              {option[displayKey]}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SCPConfigDropdown;